const subuserStatementsNL = {
    "view": {
        "table": {
            "title": "De verklaringenlijst van uw subgebruiker",
            "column": {
                "type": "Type",
                "year": "Jaar",
                "month": "Maand",
                "issue_year": "Uitgiftejaar",
                "issue_month": "Uitgiftemaand",
                "description": "Beschrijving",
                "amount": "Bedrag",
                "status": "Status",
                "details": "Details",
                "overview": "Overzicht",
                "action": "Actie"
            },
            "button": {
                "export_csv": "Exporteer CSV",
                "download": "Download"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "label": {
                "statusOpen": "Open",
                "statusPaid": "Betaald",
                "typeLicensing": "Licentie",
                "typeRegular": "Regulier",
                "typeAudioMasteringServices": "Audio Mastering - Diensten",
                "typeVinylEarnings": "Vinyl Verdiensten",
                "typeOffset": "Compensatie",
                "typeNotKnown": "Niet bekend",
                "monthJanuary": "Januari",
                "monthFebruary": "Februari",
                "monthMarch": "Maart",
                "monthApril": "April",
                "monthMay": "Mei",
                "monthJune": "Juni",
                "monthJuly": "Juli",
                "monthAugust": "Augustus",
                "monthSeptember": "September",
                "monthOctober": "Oktober",
                "monthNovember": "November",
                "monthDecember": "December"
            },
            "dropdown": {
                "markAsPaid": "Markeer als BETAALD",
                "markAsOpen": "Markeer als OPEN",
                "action": "Actie"
            },
            "message": {
                "statementUnavailable": "Alle verklaringen die eerder dan januari 2023 zijn uitgegeven, zijn beschikbaar als ZIP-bestandbijlagen in uw e-mail."
            }
        },
        "message": {
            "successMarkedOpen": "Subgebruiker verklaring is gemarkeerd als OPEN!",
            "successMarkedPaid": "Subgebruiker verklaring is gemarkeerd als BETAALD!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "markAsPaid": {
                "header": "Markeer verklaring als BETAALD",
                "body": "Weet u zeker dat u de verklaring {{statementName}} als BETAALD wilt markeren?"
            },
            "markAsOpen": {
                "header": "Markeer verklaring als OPEN",
                "body": "Weet u zeker dat u de verklaring {{statementName}} als OPEN wilt markeren?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Uw verklaringenlijst",
            "column": {
                "name": "Verklaring naam",
                "type": "Type",
                "quarter": "Kwartaal",
                "year": "Jaar",
                "month": "Maand",
                "description": "Beschrijving",
                "amount": "Bedrag",
                "status": "Status",
                "overview": "Overzicht",
                "details": "Details"
            },
            "button": {
                "download": "Download",
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "label": {
                "statusOpen": "Open",
                "statusPaid": "Betaald",
                "typeLicensing": "Licentie",
                "typeRegular": "Regulier",
                "typeAudioMasteringServices": "Audio Mastering - Diensten",
                "typeVinylEarnings": "Vinyl Verdiensten",
                "typeOffset": "Compensatie",
                "typeNotKnown": "Niet bekend",
                "quarterQ1": "K1",
                "quarterQ2": "K2",
                "quarterQ3": "K3",
                "quarterQ4": "K4",
                "monthJanuary": "Januari",
                "monthFebruary": "Februari",
                "monthMarch": "Maart",
                "monthApril": "April",
                "monthMay": "Mei",
                "monthJune": "Juni",
                "monthJuly": "Juli",
                "monthAugust": "Augustus",
                "monthSeptember": "September",
                "monthOctober": "Oktober",
                "monthNovember": "November",
                "monthDecember": "December"
            },
            "message": {
                "statementUnavailable": "Alle verklaringen die eerder dan januari 2023 zijn uitgegeven, zijn via e-mail naar uw accountmanager gestuurd."
            }
        }
    }
};

export default subuserStatementsNL;